import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { useIsDesktop } from "@utils/hooks/useIsDesktop";
import React, { useMemo } from "react";
import { zoomInAndOutAnimation, fadeInAnimation } from "./styles";

type AvatarProps = {
  alt: string;
  src: string;
  animationDurationInMs?: number;
};

const AnimatedAvatar = ({
  alt,
  src,
  animationDurationInMs = 2000,
}: AvatarProps) => {
  const isDesktop = useIsDesktop();
  const animationDuration = useMemo(
    () => animationDurationInMs / 1000,
    [animationDurationInMs]
  );
  return (
    <Box
      sx={{
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar
        sx={{
          width: 100,
          height: 100,
          animation: `${zoomInAndOutAnimation} ${animationDuration}s ease`,
        }}
        alt={alt}
        src={src}
      />
      <Typography
        color="primary.light"
        sx={{
          mt: isDesktop ? 3 : 1,
          animation: `${fadeInAnimation} ${animationDuration}s ease`,
        }}
        variant={isDesktop ? "h4" : "h6"}
      >
        Welcome...
      </Typography>
    </Box>
  );
};

export default AnimatedAvatar;
